// PaymentsHubPage — Consolidated hub for all money-related features
// Wallet, Deposit, Withdraw, Payout methods, Statements, Subscription

import { HubLayout } from './HubLayout';

export function PaymentsHubPage() {
  return (
    <HubLayout
      title="Payments"
      testIdRoot="hub-payments"
      hero={{
        title: 'Your wallet',
        subtitle: 'Manage every transaction in one place',
        emoji: '💰',
        gradient: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)',
        stats: [
          { label: 'Balance',  value: '$12,480', sub: 'USD' },
          { label: 'Pending',  value: '$240',    sub: 'processing' },
          { label: 'Lifetime', value: '$48.2K',  sub: 'paid out' },
        ],
      }}
      quickActions={[
        { to: '/portal/deposit-flow',   label: 'Add funds',     icon: '💳', testId: 'hub-payments-qa-deposit' },
        { to: '/portal/withdraw-flow',  label: 'Withdraw',      icon: '💸', testId: 'hub-payments-qa-withdraw' },
        { to: '/portal/payout-methods', label: 'Methods',       icon: '🏦', testId: 'hub-payments-qa-methods' },
      ]}
      sections={[
        {
          title: 'Wallet',
          items: [
            { to: '/portal/wallet',         icon: '👛', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Wallet overview', sub: 'Balance + recent activity', badge: { text: 'New', color: 'white', bg: '#34C759' } },
            { to: '/portal/deposit-flow',   icon: '⬇️', iconBg: 'linear-gradient(135deg, #34C759 0%, #1A8030 100%)', label: 'Add funds',     sub: 'Deposit to wallet · 5 methods' },
            { to: '/portal/withdraw-flow',  icon: '⬆️', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Withdraw',      sub: 'To bank, crypto, or PayPal' },
            { to: '/portal/payout-methods', icon: '🏦', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Payout methods', sub: 'Manage linked accounts' },
            { to: '/portal/wallet/deposit', icon: '💳', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Quick deposit', sub: '1-tap deposit' },
            { to: '/portal/wallet/withdraw',icon: '🏧', iconBg: 'linear-gradient(135deg, #FF9500 0%, #FFD60A 100%)', label: 'Quick withdraw', sub: '1-tap withdraw' },
          ],
        },
        {
          title: 'Records & Tax',
          items: [
            { to: '/portal/statements',     icon: '📑', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Statements & tax', sub: 'Monthly, YTD, download PDF' },
            { to: '/portal/statement-pdf',  icon: '📄', iconBg: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)', label: 'Download statement', sub: 'PDF for accountant' },
            { to: '/portal/payouts',        icon: '💸', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'Payouts schedule', sub: 'Past payouts' },
          ],
        },
        {
          title: 'Plan & Billing',
          items: [
            { to: '/portal/subscription',   icon: '⭐', iconBg: 'linear-gradient(135deg, #FF9500 0%, #FFD60A 100%)', label: 'Subscription',    sub: 'Mid tier · $149/mo · renews 08-12' },
            { to: '/portal/subscriptions',  icon: '📋', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'All subscriptions', sub: 'Manage plans' },
            { to: '/portal/tier-checkout',  icon: '⬆️', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Compare & upgrade', sub: 'View all 3 tiers' },
            { to: '/portal/tier-compare',   icon: '📊', iconBg: 'linear-gradient(135deg, #5856D6 0%, #FF2D55 100%)', label: 'Tier comparison', sub: 'Side-by-side benefits' },
            { to: '/portal/promotions',     icon: '🎟️', iconBg: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)', label: 'Promotions & codes', sub: 'Gold offer, referral bonus' },
          ],
        },
      ]}
    />
  );
}
